import React, { Component } from 'react';
import { MsalContext } from "@azure/msal-react";

import './Login.scss';

export default class Login extends Component {

  static contextType = MsalContext;

  state = {
    appName: "Honey Load"
  }

  render() {
    const msalInstance = this.context.instance;

    return(
      <div className="login">
        <div className="login_container">
          <div className="login_logo-bees"></div>
          <div className="login_label-name">
            {this.state.appName}
          </div>
          <div className="login_button-container">
            <button 
              className="login_button" 
              type="button"
              onClick={() => msalInstance.loginRedirect()}
              >Iniciar sesión</button>
          </div>
        </div>
      </div>
    )
  }

}
